import { useQuery } from '@tanstack/react-query';

import OffersService, {
  EligibleAppExclusiveOffersParams,
  EligibleAppExclusiveOffersResponse,
} from '~/services/OffersService';

import { appExclusiveScheduleQueryKeys } from './useGetAppExclusiveSchedules';

export const eligibleAppExclusiveOfferQueryKeys = {
  all: [...appExclusiveScheduleQueryKeys.all, 'eligible'] as const,
  list: (filters: EligibleAppExclusiveOffersParams) => [...eligibleAppExclusiveOfferQueryKeys.all, filters] as const,
};

export function useGetEligibleAppExclusiveOffers(filters: EligibleAppExclusiveOffersParams, enabled = true) {
  return useQuery({
    queryKey: eligibleAppExclusiveOfferQueryKeys.list(filters),
    queryFn: async ({ signal }): Promise<EligibleAppExclusiveOffersResponse> =>
      OffersService.getEligibleAppExclusiveOffers(filters, { signal }),
    enabled: enabled && !!filters.region && !!filters.date,
  });
}
